import { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const HydrogenGenerator = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ color = 'white', width = '24', height = '24', ...props }, ref) => {
    return (
      <SvgIcon
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 22 16"
        sx={{
          backgroundColor: (theme) => theme.palette.badge4,
          borderRadius: 4,
          padding: '2px',
          width,
          height,
        }}
        {...props}
      >
        <g id="ElectricBoltRounded">
          <g id="Group 29">
            <g id="Group 34">
              <path
                id="H"
                d="M5.86924 12.39C5.64832 12.39 5.46924 12.2109 5.46924 11.99V2.62363C5.46924 2.40272 5.64832 2.22363 5.86924 2.22363H7.36135C7.58227 2.22363 7.76135 2.40272 7.76135 2.62363V5.73738C7.76135 5.95829 7.94044 6.13738 8.16135 6.13738H10.8697C11.0906 6.13738 11.2697 5.95829 11.2697 5.73738V2.62363C11.2697 2.40272 11.4488 2.22363 11.6697 2.22363H13.1774C13.3983 2.22363 13.5774 2.40272 13.5774 2.62363V11.99C13.5774 12.2109 13.3983 12.39 13.1774 12.39H11.6697C11.4488 12.39 11.2697 12.2109 11.2697 11.99V8.54882C11.2697 8.32791 11.0906 8.14882 10.8697 8.14882H8.16135C7.94044 8.14882 7.76135 8.32791 7.76135 8.54882V11.99C7.76135 12.2109 7.58227 12.39 7.36135 12.39H5.86924Z"
                fill={color}
              />
              <path
                id="2"
                d="M14.918 13.7763V12.9689C15.3299 12.59 15.7006 12.2385 16.0301 11.9144C16.3652 11.5904 16.6288 11.2911 16.821 11.0165C17.0132 10.7418 17.1093 10.4865 17.1093 10.2503C17.1093 10.0141 17.0489 9.84113 16.9281 9.73128C16.8128 9.61595 16.659 9.55828 16.4668 9.55828C16.2965 9.55828 16.1427 9.61045 16.0054 9.7148C15.8681 9.81366 15.7363 9.92625 15.61 10.0526L14.8521 9.29465C15.1267 9.00357 15.4013 8.79212 15.6759 8.6603C15.9505 8.523 16.28 8.45435 16.6645 8.45435C17.016 8.45435 17.3263 8.52574 17.5954 8.66854C17.8645 8.80585 18.076 9.00357 18.2298 9.2617C18.3835 9.51983 18.4604 9.8219 18.4604 10.1679C18.4604 10.448 18.3835 10.7336 18.2298 11.0247C18.0815 11.3158 17.892 11.6014 17.6613 11.8815C17.4306 12.1561 17.1972 12.4142 16.9611 12.6559C17.0929 12.6394 17.2412 12.6257 17.4059 12.6147C17.5762 12.5982 17.719 12.59 17.8343 12.59H18.7076V13.7763H14.918Z"
                fill={color}
              />
            </g>
          </g>
        </g>
      </SvgIcon>
    );
  }
);

HydrogenGenerator.displayName = 'HydrogenGenerator';
